/* Lazy iframe loader – defers offscreen embeds (YouTube, Maps, etc.) */
(function(){
  function nearViewport(el){
    var r = el.getBoundingClientRect();
    return r.top < innerHeight * 1.2 && r.bottom > -innerHeight * 0.2;
  }

  function prepareFrame(f){
    if (f.classList.contains('lazy-iframe')) return;

    var src = f.getAttribute('src');
    // Skip iframes that must be immediate (e.g. critical widgets)
    if (f.hasAttribute('data-critical')) { 
      f.classList.add('lazy-iframe');
      return;
    }

    if (src && !nearViewport(f)) {
      f.setAttribute('data-src', src);
      f.removeAttribute('src');
      // Improve CLS by fixing size if available
      if (!f.hasAttribute('loading')) f.setAttribute('loading', 'lazy');
      f.setAttribute('referrerpolicy','no-referrer-when-downgrade');
    }
    f.classList.add('lazy-iframe');
  }

  function loadFrame(f){
    if (f.dataset && f.dataset.src) {
      f.src = f.dataset.src;
      f.removeAttribute('data-src');
    }
  }

  // Initial pass
  document.querySelectorAll('iframe').forEach(prepareFrame);

  // Observe future iframes added to DOM
  if ('MutationObserver' in window) {
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        (m.addedNodes || []).forEach(function(n){
          if (n.nodeType===1) {
            if (n.tagName === 'IFRAME') prepareFrame(n);
            n.querySelectorAll && n.querySelectorAll('iframe').forEach(prepareFrame);
          }
        });
      });
    }).observe(document.documentElement, {childList:true, subtree:true});
  }

  // Load when near viewport
  var frames = [].slice.call(document.querySelectorAll('iframe.lazy-iframe'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          loadFrame(e.target);
          io.unobserve(e.target);
        }
      });
    }, {rootMargin:'600px'});
    frames.forEach(function(f){ io.observe(f); });
  } else {
    // Fallback: load after a short delay
    setTimeout(function(){ frames.forEach(loadFrame); }, 1500);
  }
})();
